import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { VbrickPlayerModule } from '@vbrick/vbrick-player';

import { AngularAppBootstrapDepsModule } from 'rev-shared/bootstrap/AngularAppBootstrapDeps.Module';
import { EntryPointAngularModule } from 'rev-shared/entryPoint/EntryPointAngular.Module';
import { VbrickSharedMediaModule } from 'rev-shared/media/Media.Module';

import { AdminLoaderModule } from './admin/AdminLoader.Module';
import { DebugLoaderModule } from './debugModule/DebugLoader.Module';
import { DownloadDetailsModule } from './downloads/DownloadDetails.Module';
import { NavigationAngularModule } from './navigation/NavigationAngular.Module';
import { NotificationAngularModule } from './notifications/NotificationAngular.Module';
import { ScheduledEventsLoaderModule } from './scheduledEvents/ScheduledEventsLoader.Module';
import { SparkRootModule } from 'rev-portal/media/spark/Spark.Module';
import { TemplatesRootModule } from 'rev-shared/ui/templates/TemplatesAngular.Module';

import { configureRouter, states } from './PortalStatesV2.Config';
import { PortalAppComponent } from './PortalApp.Component';

@NgModule({
	bootstrap: [PortalAppComponent],
	imports: [
		AdminLoaderModule,
		AngularAppBootstrapDepsModule,
		DebugLoaderModule,
		DownloadDetailsModule,
		EntryPointAngularModule,
		NavigationAngularModule,
		NotificationAngularModule,
		ScheduledEventsLoaderModule,
		SparkRootModule,
		TemplatesRootModule,
		UIRouterModule.forRoot({ config: configureRouter, states, useHash: true }),
		VbrickPlayerModule,
		VbrickSharedMediaModule

	]
})
export class PortalAngularModule {}
